import React from "react"
import "./PreAssignmentPreview.scss"
import { v4 as uuidv4 } from "uuid"

const PreAssignmentPreview = ({ data, schema }) => {
  return (
    <div>
      <div className="pre-assignment-preview-title">Pre-assignment Period Milestones</div>
      <div className="pre-assignment-preview-property-container">
        <div className="pre-assignment-preview-property-title">Number of subjects started</div>
        <div className="pre-assignment-preview-property-value">
          {data?.pre_assignment_period?.started_milestone_achievement || ""}
        </div>
      </div>
      {data?.pre_assignment_period?.other_milestones?.map((milestone) => (
        <div
          className="pre-assignment-preview-property-container"
          key={uuidv4()}
        >
          <div className="pre-assignment-preview-property-title">Intermediate milestone: Number of subjects</div>
          <div className="pre-assignment-preview-property-value">
            {milestone?.title}: {milestone?.subjects}
          </div>
        </div>
      ))}
      <div className="pre-assignment-preview-property-container">
        <div className="pre-assignment-preview-property-title">Number of subjects completed</div>
        <div className="pre-assignment-preview-property-value">
          {data?.pre_assignment_period?.completed_milestone_achievement || ""}
        </div>
      </div>
      <div className="pre-assignment-preview-title">Pre-assignment subject non-completion reasons</div>
      {data?.pre_assignment_period?.not_completed_reason_details?.map((milestone) => (
        <div
          className="pre-assignment-preview-property-container"
          key={uuidv4()}
        >
          <div className="pre-assignment-preview-property-title">Reason: Number of subjects</div>
          <div className="pre-assignment-preview-property-value">
            {milestone?.title} {milestone.other_name && `- ${milestone.other_name}`}: {milestone?.subjects}
          </div>
        </div>
      ))}
    </div>
  )
}

export default PreAssignmentPreview
